



























import { Component, Vue } from 'vue-property-decorator';
import { RouteText } from '@/router';
import PersonalDocument from '@/components/profile/personal-details/documents/PersonalDocument.vue';
import { getValidationErrorText } from '@/utils/validate';
import AccountDetailsTable from '@/components/profile/personal-details/account/AccountDetailsTable.vue';
// eslint-disable-next-line no-unused-vars
import { AccountDetailsTableData } from '@/types/accountDetails';
import { getUserDocuments } from '@/api/profile';

@Component({
  components: { AccountDetailsTable, PersonalDocument },
  data: () => ({
    RouteText,
    getValidationErrorText,
    documents: [],
  }),
  validations() {
    return {
      documents: {},
    };
  },
})
export default class PersonalDetails extends Vue {
  documents: [];

  async created() {
    this.documents = await this.getUserDocuments();
  }

  async getUserDocuments() {
    return await getUserDocuments();
  }
}
